/* Small reading helpers. Each recipe still opens natively without JavaScript. */
(() => {
  'use strict';
  const folio = document.querySelector('.pb-recipe-folio');
  if (!folio || folio.dataset.recipeReadingReady) return;
  const recipes = [...folio.querySelectorAll('.pb-recipe-details')];
  const toggleAll = folio.querySelector('[data-recipe-toggle-all]');
  if (!recipes.length || !toggleAll) return;
  folio.dataset.recipeReadingReady = 'true';

  const syncLabel = () => {
    toggleAll.textContent = recipes.every(recipe => recipe.open)
      ? 'Close all recipes' : 'Open all recipes';
  };
  const openRecipe = hash => {
    let id;
    try { id = decodeURIComponent(hash.slice(1)); } catch (_) { return; }
    const card = document.getElementById(id);
    if (!card || !card.matches('.pb-recipe-card') || !folio.contains(card)) return;
    card.querySelector('.pb-recipe-details').open = true;
    syncLabel();
  };

  toggleAll.addEventListener('click', () => {
    const open = !recipes.every(recipe => recipe.open);
    recipes.forEach(recipe => { recipe.open = open; });
    syncLabel();
  });
  recipes.forEach(recipe => recipe.addEventListener('toggle', syncLabel));
  folio.querySelector('.pb-folio-index')?.addEventListener('click', event => {
    const link = event.target.closest('a[href^="#"]');
    if (!link || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    // Open before the shared navigation helper scrolls and focuses the card.
    // Do not prevent the link or replace the browser's history behavior.
    openRecipe(link.getAttribute('href'));
  });
  window.addEventListener('hashchange', () => openRecipe(location.hash));
  window.addEventListener('pageshow', syncLabel);
  openRecipe(location.hash);
  syncLabel();
  toggleAll.hidden = false;
})();
